module.exports = __webpack_public_path__ + "img/FR41219.57ca8633.png";